<template>
  <div v-show="hasAttributes" class="col-12 quick-v-attrs-out">
    <div class="row">
      <div v-for="attributeGroup in usedAttributeValuesByGroup" :key="attributeGroup.attributeGroupId" class="col-12 quick-v-attr-row">
        <attribute-image-selector
          v-if="attributeGroup.attributeDisplayType === 'image'"
          v-on:attribute-clicked="setAttributeIdAsSelectedForColor"
          :attribute-group="attributeGroup"></attribute-image-selector>
        <attribute-hex-selector
          v-else-if="attributeGroup.attributeDisplayType === 'hex-color'"
          v-on:attribute-clicked="setAttributeIdAsSelectedForColor"
          :attribute-group="attributeGroup"></attribute-hex-selector>
        <attribute-text-selector
          v-else
          v-on:attribute-clicked="setAttributeIdAsSelected"
          :attribute-group="attributeGroup"></attribute-text-selector>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../vue/store'
import { some } from 'lodash'
import AttributeTextSelector from './AttributeTextSelector'
import AttributeImageSelector from './AttributeImageSelector'
import AttributeHexSelector from './AttributeHexSelector'

export default {
  name: 'AttributeSelect',
  props: ['productId'],
  components: {
    AttributeTextSelector,
    AttributeImageSelector,
    AttributeHexSelector
  },
  data () {
    return {
      version: '0.0.1',
      selectedOptions: [],
      selectedProductCodeId: null
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    usedAttributeValuesByGroup () {
      return store.getters.getUsedAttributeValuesByGroup(this.productId)
    },
    productCodeWithAttributesMap () {
      return store.getters.getProductCodeWithAttributesMap(this.productId)
    }
  },
  mounted () {
    if (!this.hasAttributes) {
      this.selectedProductCodeId = this.productData.productCodes[0].productCodeId
    }
  },
  methods: {
    setAttributeIdAsSelectedForColor (attributeId) {
      this.$emit('product-attribute-selected', attributeId)
      this.setAttributeIdAsSelected(attributeId)
    },
    setAttributeIdAsSelected (attributeId) {
      // check if we have the selection already and do nothing
      if (this.selectedOptions.includes(attributeId)) {
        return
      }

      // check if an attribute of the same category is already selected and remove it
      let groupAttributeIds = store.getters.getOtherAttributeIdsOfGroup(attributeId)
      this.selectedOptions = this.selectedOptions.reduce((acc, item) => {
        if (!groupAttributeIds.includes(item)) {
          acc.push(item)
        }

        return acc
      }, [])

      // check if it valid to add
      let checkValid = [attributeId, ...this.selectedOptions]

      let isValid = this.productCodeWithAttributesMap.find(item => {
        return checkValid.every(subItem => item.attributes.includes(subItem))
      })

      if (!isValid) {
        this.selectedOptions = [attributeId]
      } else {
        this.selectedOptions.push(attributeId)
      }

      // if a match is found return the product code id
      let matchedCodeId = this.matchProductCode()
      if (matchedCodeId) {
        this.selectedProductCodeId = matchedCodeId
        this.$emit('matched-product-code', this.selectedProductCodeId)
      }
    },
    matchProductCode () {
      let matchedProductCode = this.productCodeWithAttributesMap.find(item => {
        return this.selectedOptions.every(subItem => item.attributes.includes(subItem)) && item.attributes.every(subItem => this.selectedOptions.includes(subItem))
      })

      return matchedProductCode ? matchedProductCode.productCodeId : null
    }
  }
}
</script>
